module.exports = __webpack_public_path__ + "img/ios.be332196.png";